var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelease2MeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "release2me_icon_on_MFP",
    "data-name": "release2me icon on MFP",
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3316",
    "data-name": "Rectangle 3316",
    width: 98,
    height: 98,
    fill: "#5f3fa5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "release2me-icon-light-mode",
    transform: "translate(22 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3245",
    "data-name": "Rectangle 3245",
    width: 58,
    height: 58,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8043",
    "data-name": "Group 8043",
    transform: "translate(2 1.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8042",
    "data-name": "Group 8042",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8037",
    "data-name": "Group 8037",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "r2me",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8036",
    "data-name": "Group 8036"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8226",
    "data-name": "Path 8226",
    d: "M45.7,13.255H30.045L43.683,9.223a2.323,2.323,0,0,0,1.542-2.846,2.42,2.42,0,0,0-2.846-1.423L23.4,10.527v-5.1A2.684,2.684,0,0,0,20.675,2.7H4.428A2.759,2.759,0,0,0,1.7,5.428V20.371H48.546V16.1A2.886,2.886,0,0,0,45.7,13.255Z",
    transform: "translate(-1.7 -2.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8227",
    "data-name": "Path 8227",
    d: "M25.446,43.132h-3.94A4.308,4.308,0,0,1,17.118,39.1H1.7v8.3a2.684,2.684,0,0,0,2.728,2.728H28.913a18.162,18.162,0,0,1-2.179-3.4A24.515,24.515,0,0,1,25.446,43.132Z",
    transform: "translate(-1.7 4.069)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8228",
    "data-name": "Path 8228",
    d: "M1.7,37.321H25.063a16.8,16.8,0,0,1,4.559-10.975A23.883,23.883,0,0,1,39.3,20H1.7Z",
    transform: "translate(-1.7 1.819)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Union_42",
    "data-name": "Union 42",
    d: "M19.561,20.988h-16A3.559,3.559,0,0,1,0,17.435V3.556A3.56,3.56,0,0,1,3.556,0h16a3.56,3.56,0,0,1,3.556,3.556V17.435A3.559,3.559,0,0,1,19.561,20.988ZM7.82,10.911c-1.35,0-2.492,1.467-2.492,3.2v3.443H17.666V14.112c0-1.794-1.094-3.2-2.492-3.2ZM11.5,3.556a3.555,3.555,0,1,0,3.556,3.556A3.634,3.634,0,0,0,11.5,3.556Z",
    transform: "translate(30.597 32.379)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_46",
    "data-name": "Union 46",
    d: "M0,7.709v-.3a7.412,7.412,0,0,1,14.825,0v.3Zm2.38-.592H12.444a5.041,5.041,0,0,0-10.064,0Z",
    transform: "translate(34.743 24.965)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelease2MeIcon);
export default __webpack_public_path__ + "static/media/release2me-icon.1d265c0558f16d52d51caadb335cf89a.svg";
export { ForwardRef as ReactComponent };